import { NgxMaterialTimepickerTheme } from 'ngx-material-timepicker';

function setAppConfig() {

    /************************************************/
    /***********  CONFIGURATION SETTINGS  ***********/
    /************************************************/

    const AppConfig = {
        appTitle: 'mBase',
        appVersion: '1.17.33',
        logoRedirect: { url: '/', externalURL: false },
        contactAddress: 'support@mturn.io',
        navbarHeight: 60,
        sidenavOpened: true,
        footerHeight: 40,
        responsiveWidth: 991,
        defaultLang: 'en_GB'
    };

    /************************************************/
    /************************************************/

    return AppConfig;
}

export const APP_CONFIG = setAppConfig();

/************************************************/
/*************  TIME PICKKER THEME  *************/
/************************************************/
export const TimePickerCustomTheme: NgxMaterialTimepickerTheme = {
    container: {
        bodyBackgroundColor: '#fff',
        buttonColor: '#00bcd4'
    },
    dial: {
        dialBackgroundColor: '#00bcd4',
    },
    clockFace: {
        clockFaceBackgroundColor: '#fff',
        clockHandColor: '#00bcd4',
        clockFaceTimeInactiveColor: '#ccc'
    }
};
/************************************************/
/************************************************/
